import gql from "graphql-tag";
const forgerMutation = gql`
  mutation forgotPassword($forgotPassword: ForgotPasswordInput!) {
    forgotPassword(forgotPassword: $forgotPassword) {
      success
      mailSent
      notConfirmed
      message
      err
    }
  }
`;

export default forgerMutation;
